export default {
  models_setDashboardModel (state, model) {
    state.models_dashboardModel = model
  },
  addedWidgetKey(state, key){
    state.addedWidgetKey = key;
  }
}
